import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthorizationComponent } from './components/authorization/authorization.component';
import { IDAMRegisterComponent } from './components/idam-register/idam-register.component';
import { AddBusinessDetailsComponent } from './components/add-business-details/add-business-details.component';
import { NotAuthGuard } from '~core/guards/not-auth.guard';
import { AuthGuard } from '~core/guards/auth.guard';
import { SSOComponent } from '~app/modules/authorization/components/fd-sso/sso.component';
import { ValidateEmailComponent } from '~app/modules/authorization/components/validate-email/validate-email.component';
// prettier-ignore
import {
  RegistrationBusinessTypeComponent
} from './components/registration-business-type/registration-business-type.component';
// prettier-ignore
import {
  VatKvkIdCheckForTierTwoSignupComponent
} from
// eslint-disable-next-line max-len
'~app/modules/authorization/components/vat-kvk-id-check-for-tier-two-signup/vat-kvk-id-check-for-tier-two-signup.component'; // NOSONAR
import { Tier2SignupGuard } from '~app/core/guards/tier-2-signup.guard';
// prettier-ignore
import {
  PasswordlessSignupComponent
} from '~app/modules/authorization/components/passwordless-signup/passwordless-signup.component';
import { LoginFlowTypeComponent } from './components/login-flow-type/login-flow-type.component';
import { BranchSelectionComponent } from './components/branch-selection/branch-selection.component';
// prettier-ignore
import {
  PasswordlessIntermediatePageComponent
} from './components/passwordless-intermediate-page/passwordless-intermediate-page.component';
import { Tier2PasswordlessGuard } from '~app/core/guards/tier2-passwordless.guard';
import { CustomersListComponent } from './components/customers-list/customers-list.component';
import { EmployeeAuthGuard } from '~app/core/guards/employee-auth.guard';

const TITLE_CONSUMER_REGISTRATION = 'TITLE.PAGE.AUTH.REGISTRATION.CONSUMER';
const TITLE_PRIVATE_OR_BUSINESS_REGISTRATION = 'TITLE.PAGE.AUTH.REGISTRATION.BUSINESS';
const TITLE_VAT_ID_CHECK_REGISTRATION = 'TITLE.PAGE.AUTH.VAT_ID_CHECK.BUSINESS';
const TITLE_BRANCH_SELECTION_REGISTRATION = 'TITLE.PAGE.AUTH.BRANCH_SELECTION.BUSINESS';
const TITLE_METRO_CARD_REGISTRATION = 'TITLE.PAGE.AUTH.REGISTRATION.METRO_CARD';
const TITLE_AUTH_REGISTRATION = 'TITLE.PAGE.AUTH.REGISTRATION';
const TITLE_AUTH_LOGIN = 'TITLE.PAGE.AUTH.LOGIN';
const TITLE_AUTH_CUSTOMER_SEARCH = 'TITLE.PAGE.AUTH.CUSTOMER_SEARCH';

const authorizationRoutes = [
  {
    path: 'customers-list',
    component: CustomersListComponent,
    canActivate: [EmployeeAuthGuard],
    data: { title: TITLE_AUTH_CUSTOMER_SEARCH },
  },
  {
    path: '',
    component: AuthorizationComponent,
    children: [
      {
        canActivate: [AuthGuard],
        path: 'fd-sso',
        component: SSOComponent,
        data: { title: TITLE_AUTH_LOGIN },
      },
      {
        path: 'validate-email',
        component: ValidateEmailComponent,
        data: { title: TITLE_AUTH_REGISTRATION },
      },
      {
        path: 'login-flow-type',
        component: LoginFlowTypeComponent,
        data: { title: TITLE_AUTH_REGISTRATION },
        canActivate: [NotAuthGuard],
      },
      {
        path: 'passwordless-signup',
        component: PasswordlessSignupComponent,
        data: { title: TITLE_AUTH_REGISTRATION },
        canActivate: [NotAuthGuard],
      },
      {
        path: 'secure-login-notice',
        data: { title: TITLE_AUTH_REGISTRATION },
        canActivate: [NotAuthGuard],
      },
      {
        path: 'passwordless-intermediate',
        component: PasswordlessIntermediatePageComponent,
        data: { title: TITLE_AUTH_REGISTRATION },
        canActivate: [AuthGuard],
      },
      {
        path: 'register',
        component: IDAMRegisterComponent,
        data: { title: TITLE_AUTH_REGISTRATION },
        canActivate: [NotAuthGuard],
      },
      {
        path: 'registration',
        children: [
          {
            canActivate: [AuthGuard, Tier2SignupGuard],
            path: 'add-business-details',
            component: AddBusinessDetailsComponent,
            data: { title: TITLE_PRIVATE_OR_BUSINESS_REGISTRATION },
          },
          {
            canActivate: [Tier2PasswordlessGuard],
            path: 'passwordless-business-details',
            component: AddBusinessDetailsComponent,
            data: { title: TITLE_PRIVATE_OR_BUSINESS_REGISTRATION },
          },
          {
            canActivate: [AuthGuard],
            path: 'registration-type',
            component: RegistrationBusinessTypeComponent,
            data: { title: TITLE_PRIVATE_OR_BUSINESS_REGISTRATION, leaveOnLogout: true },
          },
          {
            canActivate: [AuthGuard],
            path: 'check-vat',
            component: VatKvkIdCheckForTierTwoSignupComponent,
            data: { title: TITLE_VAT_ID_CHECK_REGISTRATION, leaveOnLogout: true },
          },
          {
            canActivate: [AuthGuard],
            path: 'check-tax-id',
            component: VatKvkIdCheckForTierTwoSignupComponent,
            data: { title: TITLE_VAT_ID_CHECK_REGISTRATION, leaveOnLogout: true },
          },
          {
            canActivate: [AuthGuard],
            path: 'branch-selection',
            component: BranchSelectionComponent,
            data: { title: TITLE_BRANCH_SELECTION_REGISTRATION, leaveOnLogout: true },
          },
        ],
      },
      {
        path: '',
        redirectTo: 'register',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(authorizationRoutes)],
  exports: [RouterModule],
})
export class AuthorizationRoutingModule {}
